import { render, staticRenderFns } from "./PesananPengirimanList.vue?vue&type=template&id=c66d5254&scoped=true&"
import script from "./PesananPengirimanList.vue?vue&type=script&lang=js&"
export * from "./PesananPengirimanList.vue?vue&type=script&lang=js&"
import style0 from "./PesananPengirimanList.vue?vue&type=style&index=0&id=c66d5254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66d5254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VDataTable,VDivider,VFlex,VList,VTextField,VToolbar})
